var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "signature-popup",
      staticStyle: { "background-color": "#FFFFFF" }
    },
    [
      _vm.defaultSignature.length > 0
        ? _c("img", {
            staticClass: "signature",
            staticStyle: { height: "75px", "max-width": "184px" },
            attrs: { src: _vm.defaultSignature, alt: "signature" }
          })
        : _c("div", { staticClass: "signature-box" }, [
            _vm._v("\n        Signature not available\n    ")
          ]),
      _vm._v(" "),
      _c("br"),
      _c("br"),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "signature-btn",
          attrs: { href: "javascript:void(0)" },
          on: { click: _vm.toggleModal }
        },
        [
          _c("i", { staticClass: "fa fa-pencil" }),
          _vm._v(
            " " +
              _vm._s(
                _vm.defaultSignature ? "Update signature" : "Click here to sign"
              ) +
              "\n    "
          )
        ]
      ),
      _vm._v(" "),
      _c(
        "modal",
        {
          ref: "modal",
          attrs: { heading: "Signature", "times-button": false }
        },
        [
          _c(
            "div",
            { staticStyle: { height: "450px" } },
            [
              _c(
                "tabs",
                { on: { "tab-selected": _vm.onTabSelected } },
                [
                  _c(
                    "tab",
                    {
                      staticClass: "p-4",
                      attrs: {
                        name: "Type",
                        "override-href": "type",
                        selected: true
                      }
                    },
                    [
                      _c("div", { staticStyle: { height: "320px" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.typedSignature,
                              expression: "typedSignature"
                            }
                          ],
                          attrs: { type: "text" },
                          domProps: { value: _vm.typedSignature },
                          on: {
                            input: [
                              function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.typedSignature = $event.target.value
                              },
                              _vm.updateTypedSignature
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "signature-preview dancing-script-400",
                            style: {
                              fontFamily: "Dancing Script",
                              fontSize: "2rem"
                            }
                          },
                          [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.typedSignature) +
                                "\n                        "
                            )
                          ]
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "tab",
                    {
                      staticClass: "p-4",
                      attrs: {
                        name: "Draw",
                        "override-href": "draw",
                        selected: false
                      }
                    },
                    [
                      _c("vue-signature", {
                        ref: "signature",
                        attrs: {
                          disabled: _vm.isSaving,
                          sigOption: _vm.option,
                          w: "732px",
                          h: "320px"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "tab",
                    {
                      staticClass: "p-4",
                      attrs: {
                        name: "Image",
                        "override-href": "image",
                        selected: false
                      }
                    },
                    [
                      _c("div", { staticStyle: { height: "320px" } }, [
                        _c("input", {
                          attrs: { type: "file" },
                          on: { change: _vm.onFileChange }
                        }),
                        _vm._v(" "),
                        _vm.selectedImage
                          ? _c("img", {
                              staticStyle: {
                                "max-height": "300px",
                                "max-width": "100%"
                              },
                              attrs: {
                                src: _vm.selectedImage,
                                alt: "Selected Image"
                              }
                            })
                          : _vm._e()
                      ])
                    ]
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "grid-x grid-padding-x align-right footer" },
            [
              _c("div", { staticClass: "cell shrink" }, [
                _c(
                  "button",
                  {
                    staticClass: "button success",
                    attrs: { disabled: _vm.isSaving, type: "button" },
                    on: { click: _vm.confirm }
                  },
                  [
                    _vm._v(
                      " " + _vm._s(_vm.isSaving ? "Uploading..." : "Upload")
                    )
                  ]
                ),
                _vm._v(" "),
                _c("button", {
                  ref: "submit",
                  staticClass: "d-none",
                  attrs: { type: "submit" }
                })
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "cell shrink" }, [
                _c(
                  "button",
                  {
                    staticClass: "button warning",
                    attrs: { type: "button" },
                    on: { click: _vm.toggleModal }
                  },
                  [_vm._v("Cancel")]
                )
              ])
            ]
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-bf5296ba", { render: render, staticRenderFns: staticRenderFns })
  }
}